<div class="not-applicable-form">
  <gc-input-field
    [label]="'buildingPageModal.sectionNotApplicable.reasonLabel' | translate"
    [placeholder]="
      'buildingPageModal.sectionNotApplicable.reasonPlaceholder' | translate
    "
    [value]="notApplicableReason()"
    [renderTextArea]="true"
    [rows]="6"
    (changed)="onReasonChanged($event)"
  />
  <div class="actions">
    <gc-button
      [variant]="'primary'"
      [size]="'full'"
      [disabled]="!canConfirmNotApplicable()"
      [isLoading]="isLoading()"
      (clicked)="onConfirm()"
    >
      {{
        'buildingPageModal.sectionNotApplicable.markAsNotApplicable' | translate
      }}
    </gc-button>
    <gc-button
      [variant]="'secondary'"
      [size]="'full'"
      [disabled]="isLoading()"
      (clicked)="cancelled.emit()"
    >
      {{ 'buildingPageModal.sectionNotApplicable.cancel' | translate }}
    </gc-button>
  </div>
</div>
